import imgMaquinaCitas2 from "../../image/imgMaquinaCitas2.png";
import imgPaginaTributo2 from "../../image/imgPaginaTributo2.png";
import imgEditorMarkdown2 from "../../image/imgEditorMarkdown2.png";
import imgDocumentacionTecnica from "../../image/imgDocumentacionTecnica.png";
import imgDestinoProductos from "../../image/imgDestinoProductos.png";
import imgFormularioEncuesta from "../../image/imgFormularioEncuesta.png";
import imgCajaDeRitmos from "../../image/imgCajaDeRitmos.png";
import imgCalculadoraDeJavaScript from "../../image/imgCalculadoraDeJavaScript.png";
// import imgGlobe from "../../image/imgGlobe.png";
import imgChoroplethMap from "../../image/imgChoroplethMap.png";
import imgScatterplotGraph from "../../image/imgScatterplotGraph.png";
import imgTreemapDiagram from "../../image/imgTreemapDiagram.png";
import imgInfiniteLanguageStudio from "../../image/imgInfiniteLanguageStudio.png";
import imgSocialGuamini2 from "../../image/imgSocialGuamini2.png";
import imgToDoList from "../../image/imgToDoList.png";
import imgRotiseriaPepitos2 from "../../image/imgRotiseriaPepitos2.png";

const imagesAll = {
    imgMaquinaCitas2,
    imgPaginaTributo2,
    imgEditorMarkdown2,
    imgDocumentacionTecnica,
    imgDestinoProductos,
    imgFormularioEncuesta,
    imgCajaDeRitmos,
    imgCalculadoraDeJavaScript,
    // imgGlobe,
    imgChoroplethMap,
    imgScatterplotGraph,
    imgTreemapDiagram,
    imgInfiniteLanguageStudio,
    imgSocialGuamini2,
    imgToDoList,
    imgRotiseriaPepitos2
}

export default imagesAll;